
import { Record, Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { obj_type, lambda_type, unit_type, record_type, int32_type, bool_type, option_type, union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { textColor_textNeutral600, padding_py1_5, textColor_textPrimary700, borderColor_borderPrimary600, minHeight_minH12, FocusVisible_ring, textColor_textNeutral900, borderRadius_roundedT2xl, ring_ringBlack5, ring_ring1, backgroundColor_bgSurfaceElevated, borderColor_borderNeutral100, borderColor_borderNeutral300, backgroundColor_bgNeutral100, hover, textColor_textNeutral700, tw } from "../TailwindExtensions.js";
import { margin_mt4, flexDirection_flexCol, fontWeight_fontMedium, padding_px3, borderRadius_roundedLg, display_inlineFlex, flexShrink_flexShrink0, display_inlineBlock, position_relative, padding_p2, fontWeight_fontSemibold, fontSize_textLg, justifyContent_justifyBetween, padding_p0, boxShadow_shadowXl, zIndex_z50, boxShadow_shadowLg, margin_mt2, position_right0, position_absolute, zIndex_z40, position_inset0, position_fixed$0027, margin_my1, padding_py1, padding_px2, border_border, borderRadius_roundedMd, margin_mb1, display_block, fontSize_textSm, padding_py2, padding_px4, textAlign_left, width_wFull, gap_gap$002D2, alignItems_itemsCenter, display_flex } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { item as item_1, mapIndexed, concat, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { Fragment, useEffect, useRef, useState, useReducer, createElement } from "react";
import React from "react";
import { IconName, IconWeight, IconSize, icon } from "../Icons.js";
import { payload as payload_1, channels, ChannelGroup, channelGroup, channelHref, channelLabel, channelIcon } from "../Challenge/ChallengeShare.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { concat as concat_1, replace, join } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { iterate, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { toArray, defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { disposeSafe, equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { focusLast, focusFirst, focusPrev, focusNext } from "../MenuKeyboard.js";
import { refSetter, useReturnFocusOnClose, useShowModal } from "../ModalDialog.js";
import { browserWriteText, copyLink, isDesktopViewport, browserShare, tryNativeShare, currentOrigin } from "./ShareActions.js";

export class Presentation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Dropdown", "Sheet"];
    }
}

export function Presentation_$reflection() {
    return union_type("Shared.ShareButton.Presentation", [], Presentation, () => [[], []]);
}

export class State extends Record {
    constructor(Open, Copied, CopyFailed, CopyCount) {
        super();
        this.Open = Open;
        this.Copied = Copied;
        this.CopyFailed = CopyFailed;
        this.CopyCount = (CopyCount | 0);
    }
}

export function State_$reflection() {
    return record_type("Shared.ShareButton.State", [], State, () => [["Open", option_type(Presentation_$reflection())], ["Copied", bool_type], ["CopyFailed", bool_type], ["CopyCount", int32_type]]);
}

export class Event$ extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Opened", "Closed", "CopySucceeded", "CopyFailedEvent", "CopiedExpired"];
    }
}

export function Event$_$reflection() {
    return union_type("Shared.ShareButton.Event", [], Event$, () => [[["Item", Presentation_$reflection()]], [], [], [], []]);
}

export const initialState = new State(undefined, false, false, 0);

export function update(s, e) {
    switch (e.tag) {
        case 1:
            return new State(undefined, s.Copied, false, s.CopyCount);
        case 2:
            return new State(undefined, true, false, s.CopyCount + 1);
        case 3:
            return new State(s.Open, false, true, s.CopyCount);
        case 4:
            return new State(s.Open, false, s.CopyFailed, s.CopyCount);
        default:
            return new State(e.fields[0], s.Copied, false, s.CopyCount);
    }
}

class Handlers extends Record {
    constructor(Toggle, Close, CopyLink, TriggerRef, DialogRef) {
        super();
        this.Toggle = Toggle;
        this.Close = Close;
        this.CopyLink = CopyLink;
        this.TriggerRef = TriggerRef;
        this.DialogRef = DialogRef;
    }
}

function Handlers_$reflection() {
    return record_type("Shared.ShareButton.Handlers", [], Handlers, () => [["Toggle", lambda_type(unit_type, unit_type)], ["Close", lambda_type(unit_type, unit_type)], ["CopyLink", lambda_type(unit_type, unit_type)], ["TriggerRef", lambda_type(obj_type, unit_type)], ["DialogRef", lambda_type(obj_type, unit_type)]]);
}

const noHandlers = new Handlers(() => {
}, () => {
}, () => {
}, (value_3) => {
}, (value_4) => {
});

const menuTitle = "Share this challenge";

function rowClass(minHeight) {
    return tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, width_wFull, textAlign_left, padding_px4, padding_py2, fontSize_textSm, textColor_textNeutral700, minHeight, hover(backgroundColor_bgNeutral100), "focus-visible:bg-neutral-100", "outline-none"]));
}

function opensInNewTab(channel) {
    switch (channel.tag) {
        case 0:
        case 1:
        case 3:
            return false;
        default:
            return true;
    }
}

function itemContents(channel) {
    return ["children", [createElement(icon, {
        name: channelIcon(channel),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), channelLabel(channel)]];
}

function channelItem(rowMinHeight, payload, state, h, autoFocusFirst, channel) {
    const matchValue = channelHref(channel, payload);
    if (channel.tag === 0) {
        if (state.CopyFailed) {
            return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_px4, padding_py2, fontSize_textSm, textColor_textNeutral700]))], ["children", [HtmlHelper_createElement("label", ofArray([["className", tw(ofArray([display_block, margin_mb1]))], ["htmlFor", "share-copy-url"], ["children", singleton("Copy this link:")]])), HtmlHelper_createElement("input", ofArray([["id", "share-copy-url"], ["type", "text"], ["readOnly", true], ["value", payload.Url], ["autoFocus", true], ["className", tw(ofArray([width_wFull, borderRadius_roundedMd, border_border, borderColor_borderNeutral300, padding_px2, padding_py1, fontSize_textSm]))], ["onFocus", (e) => {
                e.target.select();
            }]]))]]]));
        }
        else {
            return HtmlHelper_createElement("button", ofArray([["type", "button"], ["role", join(" ", ["menuitem"])], ["tabIndex", 0], ["autoFocus", autoFocusFirst], ["className", rowClass(rowMinHeight)], ["onClick", (_arg) => {
                h.CopyLink();
            }], itemContents(channel)]));
        }
    }
    else {
        return HtmlHelper_createElement("a", toList(delay(() => append(singleton_1(["role", join(" ", ["menuitem"])]), delay(() => append(singleton_1(["tabIndex", 0]), delay(() => append(singleton_1(["href", defaultArg(matchValue, "#")]), delay(() => append(opensInNewTab(channel) ? append(singleton_1(["target", "_blank"]), delay(() => singleton_1(["rel", "noopener noreferrer"]))) : empty(), delay(() => append(singleton_1(["className", rowClass(rowMinHeight)]), delay(() => append(singleton_1(["onClick", (_arg_1) => {
            h.Close();
        }]), delay(() => singleton_1(itemContents(channel)))))))))))))))));
    }
}

function channelItems(rowMinHeight, payload, state, h, autoFocusFirst) {
    return concat(mapIndexed((i, channel) => {
        const item = channelItem(rowMinHeight, payload, state, h, autoFocusFirst && (i === 0), channel);
        if (((i > 0) && equals(channelGroup(channel), new ChannelGroup(1, []))) && equals(channelGroup(item_1(i - 1, channels)), new ChannelGroup(0, []))) {
            return ofArray([HtmlHelper_createElement("hr", ofArray([["role", join(" ", ["separator"])], ["className", tw(ofArray([margin_my1, borderColor_borderNeutral100]))]])), item]);
        }
        else {
            return singleton(item);
        }
    }, channels));
}

function navigateMenu(e) {
    const menu = e.currentTarget;
    const matchValue = e.key;
    switch (matchValue) {
        case "ArrowDown": {
            e.preventDefault();
            focusNext(menu);
            break;
        }
        case "ArrowUp": {
            e.preventDefault();
            focusPrev(menu);
            break;
        }
        case "Home": {
            e.preventDefault();
            focusFirst(menu);
            break;
        }
        case "End": {
            e.preventDefault();
            focusLast(menu);
            break;
        }
        default:
            undefined;
    }
}

function dropdown(payload, state, h) {
    return ofArray([HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_fixed$0027, position_inset0, zIndex_z40]))], ["aria-hidden", true], ["onClick", (_arg) => {
        h.Close();
    }]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_absolute, position_right0, margin_mt2, "w-56", borderRadius_roundedMd, boxShadow_shadowLg, backgroundColor_bgSurfaceElevated, ring_ring1, ring_ringBlack5, zIndex_z50]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", padding_py1], ["role", join(" ", ["menu"])], ["aria-label", menuTitle], ["aria-orientation", "vertical"], ["onKeyDown", (e) => {
        if (e.key === "Escape") {
            e.preventDefault();
            h.Close();
        }
        else {
            navigateMenu(e);
        }
    }], ["children", channelItems("min-h-0", payload, state, h, true)]]))]]]))]);
}

function sheet(id, payload, state, h) {
    const titleId = id + "-title";
    return HtmlHelper_createElement("dialog", ofArray([["ref", (el) => {
        h.DialogRef(el);
    }], ["aria-labelledby", join(" ", [titleId])], ["className", tw(ofArray(["share-sheet", "fixed", "top-auto", "bottom-0", "inset-x-0", "m-0", "w-full", "max-w-none", backgroundColor_bgSurfaceElevated, borderRadius_roundedT2xl, boxShadow_shadowXl, "max-h-[80vh]", "overflow-y-auto", padding_p0, "backdrop:bg-black/50"]))], ["onCancel", (e) => {
        e.preventDefault();
        h.Close();
    }], ["onClick", (e_1) => {
        if (e_1.target === e_1.currentTarget) {
            h.Close();
        }
    }], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_px4, "pb-6"]))], ["children", [HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", "w-10 h-1 bg-neutral-300 rounded-full mx-auto mt-3 mb-2"]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyBetween]))], ["children", [HtmlHelper_createElement("h2", ofArray([["id", titleId], ["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton(menuTitle)]])), HtmlHelper_createElement("button", ofArray([["type", "button"], ["aria-label", "Close"], ["className", tw(ofArray([padding_p2, textColor_textNeutral700, FocusVisible_ring, borderRadius_roundedMd]))], ["onClick", (_arg) => {
        h.Close();
    }], ["children", [createElement(icon, {
        name: new IconName(36, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })]]]))]]])), HtmlHelper_createElement("div", ofArray([["role", join(" ", ["menu"])], ["aria-label", menuTitle], ["aria-orientation", "vertical"], ["onKeyDown", (e_2) => {
        navigateMenu(e_2);
    }], ["children", channelItems(minHeight_minH12, payload, state, h, false)]]))]]]))]]]));
}

function elementId(ch, label) {
    return `share-${ch.Id}-${replace(label, " ", "-").toLowerCase()}`;
}

/**
 * React key for the stateful button: when the displayed challenge changes (SPA back/forward),
 * the button remounts so its payload, open menu and pending native-share result are discarded.
 */
export function instanceKey(label, ch) {
    return elementId(ch, label);
}

function render(id, label, payload, state, h) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_relative, display_inlineBlock, flexShrink_flexShrink0]))], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("button", ofArray([["ref", (el) => {
        h.TriggerRef(el);
    }], ["id", id], ["type", "button"], ["aria-haspopup", "menu"], ["aria-expanded", (state.Open != null) ? "true" : "false"], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, borderRadius_roundedLg, "border-2", borderColor_borderPrimary600, textColor_textPrimary700, padding_px3, padding_py1_5, fontSize_textSm, fontWeight_fontMedium, FocusVisible_ring]))], ["onClick", (_arg) => {
        h.Toggle();
    }], ["children", toList(delay(() => (state.Copied ? append(singleton_1(createElement(icon, {
        name: new IconName(73, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })), delay(() => singleton_1("Link copied"))) : append(singleton_1(createElement(icon, {
        name: new IconName(67, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })), delay(() => singleton_1(label))))))]]))), delay(() => append(singleton_1(HtmlHelper_createElement("span", ofArray([["aria-live", "polite"], ["className", "sr-only"], ["children", singleton(state.Copied ? "Link copied" : "")]]))), delay(() => {
        const matchValue = state.Open;
        let matchResult, p, p_1;
        if (matchValue != null) {
            if (matchValue.tag === 1) {
                if (payload != null) {
                    matchResult = 1;
                    p_1 = payload;
                }
                else {
                    matchResult = 2;
                }
            }
            else if (payload != null) {
                matchResult = 0;
                p = payload;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return dropdown(p, state, h);
            case 1:
                return singleton_1(sheet(id, p_1, state, h));
            default: {
                return empty();
            }
        }
    }))))))]]));
}

/**
 * Renders any state against a payload built from `baseUrl`, with inert handlers.
 */
export function renderState(baseUrl, label, ch, state) {
    return render(elementId(ch, label), label, payload_1(baseUrl, ch), state, noHandlers);
}

function ShareButtonComponent($props) {
    const ch = $props.ch;
    const label = $props.label;
    const patternInput = useReducer(update, initialState);
    const state = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useState(undefined);
    const payload = patternInput_1[0];
    const triggerRef = useRef(undefined);
    const dialogRef = useRef(undefined);
    useShowModal(dialogRef, state.Open);
    useReturnFocusOnClose(triggerRef, state.Open != null);
    const dependencies = [state.Copied, state.CopyCount];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const timer = state.Copied ? window.setTimeout(() => {
            dispatch(new Event$(4, []));
        }, 2000) : undefined;
        disp = {
            Dispose() {
                iterate((handle) => {
                    window.clearTimeout(handle);
                }, toArray(timer));
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    const handlers = new Handlers(() => {
        if (state.Open != null) {
            dispatch(new Event$(1, []));
        }
        else {
            const matchValue = payload_1(currentOrigin(), ch);
            if (matchValue != null) {
                const p = matchValue;
                patternInput_1[1](p);
                const pr = tryNativeShare(browserShare(), p);
                void (pr.then((outcome) => {
                    switch (outcome.tag) {
                        case 2:
                        case 3: {
                            dispatch(new Event$(0, [isDesktopViewport() ? (new Presentation(0, [])) : (new Presentation(1, []))]));
                            break;
                        }
                        default:
                            undefined;
                    }
                }));
            }
        }
    }, () => {
        dispatch(new Event$(1, []));
    }, () => {
        iterate((p_1) => {
            const pr_1 = copyLink(browserWriteText(), p_1.Url);
            void (pr_1.then((outcome_1) => {
                if (outcome_1.tag === 1) {
                    dispatch(new Event$(3, []));
                }
                else {
                    dispatch(new Event$(2, []));
                }
            }));
        }, toArray(payload));
    }, (el) => {
        refSetter(triggerRef, el);
    }, (el_1) => {
        refSetter(dialogRef, el_1);
    });
    return render(elementId(ch, label), label, payload, state, handlers);
}

/**
 * Share trigger. `label` is "Share" (page, hero) or "Share this challenge" (pledge card).
 * Native share runs first on the client; the fallback menu opens only when it is unavailable or fails.
 */
export function view(label, ch) {
    return createElement(Fragment, {
        key: instanceKey(label, ch),
    }, createElement(ShareButtonComponent, {
        label: label,
        ch: ch,
    }));
}

/**
 * Prompt line plus a "Share this challenge" button for the supporter's pledge card.
 */
export function supporterPrompt(ch) {
    let who;
    const matchValue = ch.HostFirstName;
    who = ((matchValue == null) ? "this challenge" : matchValue);
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, gap_gap$002D2, margin_mt4]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton(concat_1("Help ", who, " reach more supporters"))]])), view(menuTitle, ch)]]]));
}

//# sourceMappingURL=ShareButton.js.map
